'use strict';

angular.module('kerp-forms.forms').factory(
  'CAL_FCA_CONDITIONS',
  [
    'FormConditions',
    'numberUtils',

    function (
      FormConditions,
      numberUtils
    ) {

      function hasContribution(careAssessment) {
        let hasContribution = false;
        if (careAssessment) {
          hasContribution = numberUtils.isNumeric(careAssessment.maxContribution);
        }
        return hasContribution;
      }

      return FormConditions.clone({
        conditions: {
          'person.property.value': function () {
            return this.lib.isAnyOf('person.property.ownership', ['ownedByYou', 'ownedJointly']);
          },

          'person.intro.excludeNonResidentialCaretypes': function() {
            var excludeNonResidentialCaretypes = this.lib.getModelValue('person.intro.excludeNonResidentialCaretypes');
            var provideFinancialDetails = this.lib.getModelValue('person.intro.provideFinancialDetails');

            // residential care types should be visible only if the user has chosen to complete DRE
            // OR they have chosen not to agree to provide their financial details
            return !excludeNonResidentialCaretypes || provideFinancialDetails !== 'agree';
          },

          'person.income.attendanceAllowance': function () {
            var hasDlaCare = this.lib.isAnyOf('person.income.dlaCare', ['high', 'medium', 'low']);
            var hasPipDla = this.lib.isAnyOf('person.income.pipDailyLiving', ['high', 'low']);

            return !hasDlaCare && !hasPipDla;
          },

          'person.income.dlaCare': function () {
            var hasAA = this.lib.isAnyOf('person.income.attendanceAllowance', ['high', 'low']);
            var hasPipDla = this.lib.isAnyOf('person.income.pipDailyLiving', ['high', 'low']);

            return !hasAA && !hasPipDla;
          },

          'person.income.pipDailyLiving': function () {
            var hasAA = this.lib.isAnyOf('person.income.attendanceAllowance', ['high', 'low']);
            var hasDlaCare = this.lib.isAnyOf('person.income.dlaCare', ['high', 'medium', 'low']);

            return !hasAA && !hasDlaCare;
          },

          'partner.income.attendanceAllowance': function () {
            var hasDlaCare = this.lib.isAnyOf('partner.income.dlaCare', ['high', 'medium', 'low']);
            var hasPipDla = this.lib.isAnyOf('partner.income.pipDailyLiving', ['high', 'low']);

            return !hasDlaCare && !hasPipDla;
          },

          'partner.income.dlaCare': function () {
            var hasAA = this.lib.isAnyOf('partner.income.attendanceAllowance', ['high', 'low']);
            var hasPipDla = this.lib.isAnyOf('partner.income.pipDailyLiving', ['high', 'low']);

            return !hasAA && !hasPipDla;
          },

          'partner.income.pipDailyLiving': function () {
            var hasAA = this.lib.isAnyOf('partner.income.attendanceAllowance', ['high', 'low']);
            var hasDlaCare = this.lib.isAnyOf('partner.income.dlaCare', ['high', 'medium', 'low']);

            return !hasAA && !hasDlaCare;
          },

          'person.income.universalCredit': function () {
            var uc = this.lib.getModelValue('person.income.universalCredit');
            return uc > 0;
          },

          showBreakdownNonResidential: function () {
            var contribution = hasContribution(this.lib.getModelValue('careAssessment.nonResidential'));
            var provideFinancialDetails = this.lib.getModelValue('person.intro.provideFinancialDetails') === 'agree';
            var isMaxCost = this.lib.getModelValue('careAssessment.nonResidential.isMaxCost');
            return contribution && provideFinancialDetails && !isMaxCost;
          },

          showBreakdownRespite: function () {
            var contribution = hasContribution(this.lib.getModelValue('careAssessment.respite'));
            var provideFinancialDetails = this.lib.getModelValue('person.intro.provideFinancialDetails') === 'agree';
            return contribution && provideFinancialDetails;
          },

          showBreakdownWeek1Residential: function () {
            var contribution = hasContribution(this.lib.getModelValue('careAssessment.week1Residential'));
            var provideFinancialDetails = this.lib.getModelValue('person.intro.provideFinancialDetails') === 'agree';
            return contribution && provideFinancialDetails;
          },

          showBreakdownWeek5Residential: function () {
            var contribution = hasContribution(this.lib.getModelValue('careAssessment.week5Residential'));
            var provideFinancialDetails = this.lib.getModelValue('person.intro.provideFinancialDetails') === 'agree';
            return contribution && provideFinancialDetails;
          },

          showBreakdownWeek13Residential: function () {
            var contribution = hasContribution(this.lib.getModelValue('careAssessment.week13Residential'));
            var provideFinancialDetails = this.lib.getModelValue('person.intro.provideFinancialDetails') === 'agree';
            return contribution && provideFinancialDetails;
          },


        }
      });
    }]);
